<mip-scroll-fix *ngIf="profile" [top]="isMobile ? 0 : 75" [marginTop]="isMobile ? 0 : 75">
  <mip-profile-top-toolbar [profile]="profile" [backPathReferrer]="backPathReferrer"></mip-profile-top-toolbar>
</mip-scroll-fix>

<div class="__loading-profile" *ngIf="loadingProfile">
  <mip-loading></mip-loading>
</div>

<div class="profile-page-content" [class.--is-mobile]="isMobile" [class.--is-desktop]="isDesktop" *ngIf="profile">
  <!-- PROFILE-HEADER -->
  <mip-profile-header [profile]="profile"></mip-profile-header>

  <!-- PROFILE-BADGES -->
  <mip-profile-badges [profile]="profile"></mip-profile-badges>

  <!-- PROFILE-ACTIONS -->
  <div class="__actions" *ngIf="isMobile">
    <mip-profile-user-actions [profile]="profile" *ngIf="profile.isAuthenticated"></mip-profile-user-actions>

    <mip-profile-public-actions [profile]="profile" *ngIf="!profile.isAuthenticated"></mip-profile-public-actions>
  </div>

  <!-- PROFILE-FEED -->
  <mip-feed-grid
    class="__grid-list"
    *ngIf="loadingPosts || postsList.length > 0 || !profile.isAuthenticated"
    [loading]="loadingPosts"
    [postsList]="postsList"
    [page]="lastPostId"
    [columns]="isMobile ? 3 : 4"
    [postsCount]="postsList.length"
    [enableVideoPreview]="false"
    [backTopMarginTop]="isDesktop ? 160 : 60"
    baseRoute="/@{{ profile.username }}/p"
    (onReachedBottom)="getPosts()"
  ></mip-feed-grid>

  <mip-download-app-first-post class="__first-post" *ngIf="!loadingPosts && postsList.length === 0 && profile.isAuthenticated"></mip-download-app-first-post>
</div>

<!-- MODAL OUTLET -->
<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>
